export const BACKGROUNDS = [["white", "White"], ["ivory", "Ivory"], ["alt", "Warm beige"], ["charcoal", "Charcoal (dark)"]];

export const SECTION_TYPES = {
  hero: { label: "Hero banner", defaults: { title: "Page title", subtitle: "", image: "", button_text: "", button_url: "", background: "charcoal" } },
  text: { label: "Text block", defaults: { title: "", body_html: "<p>Write your text here…</p>", background: "white" } },
  image_text: { label: "Image + text", defaults: { title: "", body_html: "", image: "", image_side: "right", button_text: "", button_url: "", background: "ivory" } },
  image: { label: "Single image", defaults: { image: "", image_width: "100", caption: "", background: "white" } },
  cards: { label: "Cards", defaults: { title: "", items: [{ title: "Card title", body: "", image: "", link_text: "", link_url: "" }], background: "alt" } },
  gallery: { label: "Image carousel", defaults: { title: "", images: [], background: "ivory" } },
  cta: { label: "Call-to-action band", defaults: { title: "", body_html: "", button_text: "", button_url: "", background: "charcoal" } },
  embed: { label: "Embed (form / iframe)", defaults: { title: "", url: "", height: "800", background: "white" } },
  pdf: { label: "PDF viewer + download", defaults: { pdf: "", button_text: "Download PDF", background: "charcoal" } },
};

export const newSection = (type) => ({
  id: Math.random().toString(36).slice(2, 10),
  type,
  data: JSON.parse(JSON.stringify(SECTION_TYPES[type].defaults)),
});
